import React from 'react';

const analyticsEnv = process.env.GATSBY_ANALYTICS_ENV;

const datadomainProduction = 'e29ddee0-6056-458d-8435-62eb141e89c3';
const datadomainScript = 'e29ddee0-6056-458d-8435-62eb141e89c3-test';

// react-helmet will see this difference and update the script tag, which causes it to execute twice.
// by specifying the value as empty string on the client, we can avoid this re-execution.

// const booleanAttribute = (typeof window === 'undefined' ? true : '') as any;

export type SetConsentProfileParameter = {
  purposes: {
    Id: string;
    TransactionType: string;
  }[];
};

declare global {
  interface Window {
    OneTrust?: {
      LoadBanner: () => void;
      Init: () => void;
      ToggleInfoDisplay: () => void;
      initializeCookiePolicyHtml: () => void;
      setConsentProfile: (e: SetConsentProfileParameter) => void;
      UpdateConsent: (selector: string, action: string) => void;
      OnConsentChanged: (callback: (e: { detail: string[] }) => void) => void;
    };
    OnetrustActiveGroups?: string;
  }
}

export const onetrustScript: JSX.Element = (
  <script
    src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js"
    type="text/javascript"
    data-domain-script={
      analyticsEnv === 'production' ? datadomainProduction : datadomainScript
    }
  />
);

// See https://my.onetrust.com/s/article/UUID-29158b4e-22f6-0067-aa36-94f3b8cf3561?language=en_US
// The OptanonWrapper function is called after banner script execution.
// The banner script will be executed when the user changes their consent of cookie categories
// We are dispatching an event for the VideoCookieNotice component
export const onetrustScriptOptanon: JSX.Element = (
  <script type="text/javascript">
    function OptanonWrapper() &#123; window.dispatchEvent(new
    Event("oneTrustBannerScriptExecuted")); &#125;
  </script>
);

export const reloadOneTrust = (): void => {
  if (window.OneTrust) {
    setTimeout(() => {
      window.OneTrust?.Init();
      window.OneTrust?.LoadBanner();
      window.OneTrust?.initializeCookiePolicyHtml();

      const toggleDisplay = document.getElementsByClassName('ot-sdk-show-settings');

      for (let i = 0; i < toggleDisplay.length; i += 1) {
        const toggleButton = toggleDisplay[i] as HTMLButtonElement;
        toggleButton.onclick = (event) => {
          event.stopImmediatePropagation();
          window.OneTrust?.ToggleInfoDisplay();
        };
      }
    }, 1000);
  }
};
